import React from 'react';
import { TagListProps } from '../types';
import { Tag } from '../Tag/Tag';
import { cn } from '../../../../lib/utils';
import { staggerContainer, withReducedMotion, viewportOptions } from '../../../../lib/animations/variants';
import { motion } from 'framer-motion';

const spacingStyles = {
  sm: 'gap-2',
  md: 'gap-3',
  lg: 'gap-4'
};

export const TagList: React.FC<TagListProps> = ({
  tags,
  variant = 'default',
  size = 'md',
  layout = 'wrap',
  spacing = 'md',
  className
}) => {
  const containerStyles = cn(
    layout === 'wrap' 
      ? 'flex flex-wrap' 
      : 'flex overflow-x-auto',
    spacingStyles[spacing],
    className
  );

  const content = (
    <div className={containerStyles}>
      {tags.map((tag, index) => (
        <Tag
          key={`${tag.label}-${index}`}
          {...tag}
          variant={tag.variant || variant}
          size={tag.size || size}
        />
      ))}
    </div>
  );

  return (
    <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={viewportOptions}
        variants={staggerContainer}
    >
      {content}
    </motion.div>
  );
};